// src/redux/auth/authApi.js
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Login API
export const loginAPI = async (credentials) => {
  try {
    const response = await apiService.post(endpoints.login, credentials);
    return response.data; // ✅ returns { success, message, data }
  } catch (error) {
    throw error;
  }
};

// ✅ Register API
export const registerAPI = async (userData) => {
  try {
    const response = await apiService.post(endpoints.register, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Logout API
export const logoutAPI = async () => {
  try {
    const response = await apiService.post(endpoints.logout);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Forgot Password API
export const forgotPasswordAPI = async (email) => {
  try {
    const response = await apiService.post(endpoints.forgotPassword, { email });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Reset Password API
// export const resetPasswordAPI = async (payload) => {
//   try {
//     const response = await apiService.post(endpoints.resetPassword, payload);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };
// ✅ Reset Password API - Token in header
export const resetPasswordAPI = async ({ payload, token }) => {
  try {
    const response = await apiService.post(
      endpoints.resetPassword, 
      payload,
      {
        headers: {
          'Authorization': `Bearer ${token}` // or whatever header format your API expects
          // Alternative formats you might need:
          // 'x-auth-token': token
          // 'reset-token': token
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
// ✅ Verify Email API
export const verifyEmailAPI = async (token) => {
  try {
    const response = await apiService.get(`${endpoints.verifyEmail}/${token}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Profile API
export const updateProfileAPI = async (profileData) => {
  try {
    const response = await apiService.put(endpoints.updateProfile, profileData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Change Password API
export const changePasswordAPI = async (passwordData) => {
  try {
    const response = await apiService.post(endpoints.changePassword, passwordData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Refresh Token API
export const refreshTokenAPI = async () => {
  try {
    const response = await apiService.get(endpoints.refreshToken);
    return response.data;
  } catch (error) {
    throw error;
  }
};



// ✅ Role List API
export const getRoleListAPI = async (params = {}) => {
  try {
   
    const response = await apiService.get(endpoints.roleList, params);
    
    return response.data;
  } catch (error) {
    throw error;
  }
};
